import { useContext } from 'react';
import { TagContext, AccountContext } from './TagContext/TagContext';

/**
 * We assume tagData is not null inside provider
 */
export const useTagData = () => useContext(TagContext).tagData!;
export const useAccountData = () => useContext(AccountContext);
